import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#033B5D] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <Link to="/" className="inline-block mb-4 group">
              <div className="bg-white p-4 rounded-xl shadow-lg group-hover:shadow-xl transition-all duration-300">
                <img 
                  src="/images/logo.png" 
                  alt="Ma Prime Adapt' - Adaptation logement senior, aides financières" 
                  className="h-20 object-contain"
                />
              </div>
            </Link>
            <p className="text-gray-300 text-sm">
              Prime-Adapt-Seniors est un service d'accompagnement indépendant et non un organisme public.
            </p>
            <p className="text-gray-300 text-sm mt-4">
              <strong>SA ENERGO SYM</strong>
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p className="text-gray-300 mb-2">
              <span className="text-xl font-bold text-amber-400">09.70.70.70.69</span>
            </p>
            <p className="text-gray-300 text-sm">
              Du lundi au vendredi<br />
              9h - 18h
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Nos services</h3>
            <ul className="space-y-2">
              <li><Link to="/douche-senior" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Douche senior</Link></li>
              <li><Link to="/monte-escalier" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Monte-escalier</Link></li>
              <li><Link to="/adaptation-salle-de-bain" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Adaptation salle de bain</Link></li>
              <li><Link to="/ma-prime-adapt" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Ma Prime Adapt'</Link></li>
              <li><Link to="/aide-adaptation-logement" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Aides adaptation</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Blog</Link></li>
              <li><Link to="/nos-realisations" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Nos réalisations</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-amber-400 transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Liens SEO locaux */}
        <div className="border-t border-gray-700 pt-6 pb-6">
          <h3 className="text-sm font-semibold mb-3 text-gray-400">Zones d'intervention</h3>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            <Link to="/adaptation-logement-paris" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Paris (75)</Link>
            <Link to="/adaptation-logement-seine-et-marne" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Seine-et-Marne (77)</Link>
            <Link to="/adaptation-logement-yvelines" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Yvelines (78)</Link>
            <Link to="/adaptation-logement-essonne" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Essonne (91)</Link>
            <Link to="/adaptation-logement-hauts-de-seine" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Hauts-de-Seine (92)</Link>
            <Link to="/adaptation-logement-seine-saint-denis" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Seine-Saint-Denis (93)</Link>
            <Link to="/adaptation-logement-val-de-marne" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Val-de-Marne (94)</Link>
            <Link to="/adaptation-logement-val-doise" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Val-d'Oise (95)</Link>
            <Link to="/adaptation-logement-oise" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Oise (60)</Link>
            <Link to="/adaptation-logement-aisne" className="text-gray-400 hover:text-amber-400 transition-colors text-xs">Aisne (02)</Link>
          </div>
        </div>

        {/* Liens légaux */}
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex gap-6">
            <Link to="/mentionslegales" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Mentions légales</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Politique de confidentialité</Link>
          </div>
          <div className="text-gray-400 text-sm">
            <p>&copy; {new Date().getFullYear()} Ma Prime Adapt' - SA ENERGO SYM. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
